// extracted by mini-css-extract-plugin
export default {"redFont":"_1D5j2ggVNwCdW5ECG2YPo6","greenFont":"_5R-YF0y8wExbjT6g59R1K","orangeFont":"cI7g1AODdDJUf-q67KeUZ","filters":"_1Kr-YeUL7XwFiugbvuwY75"};